import { render, staticRenderFns } from "./FleetVehicle.vue?vue&type=template&id=f4d879ca&scoped=true"
import script from "./FleetVehicle.vue?vue&type=script&lang=js"
export * from "./FleetVehicle.vue?vue&type=script&lang=js"
import style0 from "./FleetVehicle.vue?vue&type=style&index=0&id=f4d879ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d879ca",
  null
  
)

export default component.exports